const BASE_URL = process.env.REACT_APP_API_URL || 'http://gec.energymarketplace.in/gec-backend/api/v1';

const API_ENDPOINTS = {
    // Auth endpoints
    AUTH: {
        LOGIN: '/auth/login',
        LOGOUT: '/api/auth/logout',
        REFRESH: '/auth/refresh-tokens',
        PROFILE: '/auth/profile',
        ME: '/auth/me'
    },
    UPLOAD_DOCUMENT: "/document/upload",
    CONSUMER_DETAILS_BY_CONSUMER_NO: "/company/consumer/details",
    DROPDOWN: {
        TIMESLOTS: "/dropdowns/timeslots"
    },
    DASHBOARD: {
        OVERVIEW: "/dashboard/admin/overview",
        GENERATOR_GRAPH: "/dashboard/admin/chart/generation",
        CONSUMPTION_GRAPH: "/dashboard/admin/chart/consumption",
        RECENT_REPORT_LIST: "/admin/recent/activity",
        ENERGY_HEATMAP: "/dashboard/admin/chart/heatmap",
        GENERATION_ENERGY_HEATMAP: "/dashboard/admin/chart/generation-heatmap",
        ENERGY_HEATMAP_SLOT_DETAILS: "/dashboard/consumer/generator-settlements",
        // generator-tooltip-list
        GENERATOR_TOOLTIP_LIST: "/dashboard/admin/generator/tooltip/list",
        GENERATOR_TOLLTIL_SUMMARY: "/dashboard/admin/generator/tooltip/summary",
        CONSUMER_TOLLTIL_SUMMARY: "/dashboard/admin/consumer/tooltip/summary",
        CONSUMER_TOLLTIL_LIST: "/dashboard/admin/consumer/tooltip/list"



    },
    ENERGY_AUDIT: {
        CONSUMER: {
            COSNUMER_DETAILS: "/dashboard/admin/consumer/audit/summary",
            REPORT: "/dashboard/admin/consumer/audit/list"
        },
        GENERATOR: {
            COSNUMER_DETAILS: "/dashboard/admin/generator/audit/summary",
            REPORT: "/dashboard/admin/generator/audit/list"
        }
    },
    ENERGY_MONITORING_DASHBOARD: {
        GENERATION: {
            GENERATOR: {
                STATS: "/dashboard/admin/chart/generation/summary",
                CHART: "/dashboard/admin/chart/renewable"
            },
            CONSUMER: {
                STATS: "/dashboard/admin/chart/consumption/summary",
                CHART: "/dashboard/admin/chart/consumption/renewable"
            },
        },
        SETTELED: {
            GENERATOR: {
                STATS: "/dashboard/admin/chart/generation/summary",
                CHART: "/dashboard/admin/chart/generation"
            },
            CONSUMER: {
                STATS: "/dashboard/admin/chart/consumption/summary",
                CHART: "/dashboard/admin/chart/consumption"
            }
        }
    },

    SYSTEM_PERFORMANCE: {
        REALTIME_OVERVIEW: "dashboard/admin/realtime/overview",
        REALTIME_REPORT: "dashboard/admin/realtime/readings",
    },
    ONBOARDING: {
        GENERATORS: {
            REPORT: "/dashboard/generator/list",
            CREATE: "/admin/generators/create",
            UPDATE_STATUS: (id: string) => `/admin/generators/${id}/status`,
            DETAILS: "/dashboard/generator/:consumerId/details",
        },
        CONSUMER: {
            REPORT: "/dashboard/consumer/list",
            CREATE: "/admin/consumer/create",
            DETAILS: "/dashboard/consumer/:consumerId/details",
            UPDATE_STATUS: (id: string) => `/admin/generators/${id}/status`
        },
        ADMIN: {
            REPORT: "",
            CREATE_ADMIN_USER: "/admin/create",
            LIST_ADMIN_USER: "/admin/list",

            UPDATE_STATUS: ""
        }
    },
    SELF_SERVICE: {
        QUERY_REQUEST: {
            ALL_REQUESTS: "/admin/ticket/list",
            POST_QUERY_REQUEST: "/ticket/raise",
            QUERY_DETAILS: "/admin/ticket/details/:ticketId",
            COMMENT: "/ticket/comment"
        }
    },
    GEC_REPORT: {
        REPORT: "/dashboard/admin/ge-certificate",
        REPORT_DETAILS: (id: string) => `/dashboard/admin/ge-certificate/${id}/detail`,
        CERTIFICATE_DETAILS: "/dashboard/admin/ge-certificate/:certificateId/info",

    },
    TOKENS_MANAGEMENT: {
        DASHBOARD: {
            TOKEN_OVERVIEW: "/dashboard/admin/token/overview",
            TOKEN_REPORT_LIST: "/admin/generator/tokens/list",

            STATS: "",
        },
        GENERATION_REPORT: "/dashboard/admin/token/generation"
    },

    CONFIGURATION: {
        TIME_BLOCK_FORM: "/config/timeblock",
        TIME_BLOCK_REPORT: "/config/timeblock",
        ENERGY_SETTING_FORM: "/config/energy-setting",
        ENERGY_SETTING_REPORT: "/config/energy-setting",




    }
    // Add more endpoints as needed
} as const;

export {
    BASE_URL,
    API_ENDPOINTS
}